import React from 'react'
import List from '../pages/list'

export const PagesGenuineList = (props) => <List {...props} filter={{ collection: 'genuine' }} title="Pages Genuine" />

export default PagesGenuineList
